<template>
  <table
    ref="table"
    class="c-table c-table--prefecture"
    :class="[classes ? classes : '']"
  >
    <thead>
      <tr>
        <th class="c-table__cell--center u-w54"></th>
        <th class="c-table__cell--center is-sortable">
          <span class="c-table__text">地域</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'id' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'id' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'id') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">配信対象数</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'delivery' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'delivery' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'delivery') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">インプレッション</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'impression' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'impression' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'impression') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">クリック数</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'click' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'click' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'click') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">クリック率(%)</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'ctr' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'ctr' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'ctr') }"
          ></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="index of 47" :key="index">
        <td class="c-table__cell--center c-table__cell--middle">{{ index }}</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import * as d3 from 'd3';

export default {
  props: {
    classes: { type: String, required: false },
    onSortClick: { type: Function, required: true },
  },
  data() {
    return {
      chartElements: {
        table: null,
      },
      columns: {},
      period: {},
      sort: {},
      tooltipData: {
        prefectureId: '',
      },
    }
  },

  mounted: function() {
    this.chartElements.table = d3.select(this.$refs.table);
  },

  methods: {
    init: function(data, period, sort) {
      // 日付、表示カラム、ソート指定を保存
      this.period = period;
      this.sort = sort;

      // prefectureIdをidというキーで追加
      data.items = data.items.map((item) => {
        item.id = item.prefectureId;
        return item;
      })

      // 都道府県データを設定
      const tableData = data.items;

      // テーブル表示データのソート処理
      tableData.sort(function (a, b) {
        return (sort.type.toLowerCase() == 'asc') ? a[sort.key] - b[sort.key] : b[sort.key] - a[sort.key] ;
      });

      // フォーマッター設定
      const numberFormatter = new Intl.NumberFormat('ja-JP', {
        setMaximumFractionDigits: 1,
      });
      const percentFormatter = new Intl.NumberFormat('ja-JP', {
        style: 'percent',
        maximumFractionDigits: 2,
      });

      // 地域別配信数テーブル更新
      this.chartElements.table
        .selectAll('tbody tr')
        .each((d, i, nodes) => {
          const summary = tableData[i];

          // 表示用データ作成
          const displayData = {
            prefecture: summary.prefecture,
            delivery: numberFormatter.format(summary.delivery),
            impression: numberFormatter.format(summary.impression),
            click: numberFormatter.format(summary.click),
            ctr: Number(percentFormatter.format(summary.ctr).replace(',', '').replace('%', '')).toFixed(2),
          }

          // プロパティ値には、実数値を設定
          d3.select(nodes[i])
            .property('prefecture', summary.prefecture)
            .property('click', summary.click)
            .property('ctr', summary.ctr)
            .property('delivery', summary.delivery)
            .property('impression', summary.impression);

          nodes[i].children[1].textContent = displayData.prefecture;
          nodes[i].children[2].textContent = displayData.delivery;
          nodes[i].children[3].textContent = displayData.impression;
          nodes[i].children[4].textContent = displayData.click;
          nodes[i].children[5].textContent = displayData.ctr;
        })
    },

    updateSort: function(e, key) {
      // クリックしたソートボタンの状態で昇順・皇潤を判定 && ソートボタンの表示を切り替え
      if (e.target.classList.contains('c-btn--sort-desc')) {
        this.sort.key = key;
        this.sort.type = 'asc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-asc');
      } else {
        this.sort.key = key;
        this.sort.type = 'desc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-desc');
      }
      this.onSortClick(this.sort);
    },
  },
}
</script>
